import BaseController from "../../controller/BaseController";
import JSONModel from "sap/ui/model/json/JSONModel";
import DataService from "../../util/DataService";
import Filter from "sap/ui/model/Filter";
import { SearchField$LiveChangeEvent } from "sap/m/SearchField";
import FilterOperator from "sap/ui/model/FilterOperator";
import ListBinding from "sap/ui/model/ListBinding";

/**
 * @namespace com.reply.leaviosa.controller
 */
export default class DispoController extends BaseController {

    public async onInit(): Promise<void> {

        const oRouter = this.getOwnerComponent().getRouter();
        oRouter.getRoute("project").attachPatternMatched(this.onObjectMatched, this);
        oRouter.getRoute("team").attachPatternMatched(this.onObjectMatched, this);
        oRouter.getRoute("department").attachPatternMatched(this.onObjectMatched, this);
        this.onObjectMatched();

    }

    async onObjectMatched(): Promise<void> {
        const viewModel = new JSONModel({
            dialogBusy: false,
            year: new Date(),
            projectId: null,
            departmentId: null,
            teamId: null,
            leaveType: 'all',
        });


        const hash = this.getView().getController().getOwnerComponent().getRouter().oHashChanger.hash
        const object = hash.split("/")[0];
        const id = hash.split("/")[1];
        if (object === "project") {
            viewModel.setProperty("/projectId", id);
        } else if (object === "department") {
            viewModel.setProperty("/departmentId", id);
        } else if (object === "team") {
            viewModel.setProperty("/teamId", id);
        }

        this.getView().setModel(viewModel, "viewModel");
        this.getDispoData();
    }

    private getDispoData(): void {
        const viewModel = this.getView().getModel("viewModel") as JSONModel;
        const year = viewModel.getProperty("/year").getFullYear();
        const leaveType = viewModel.getProperty("/leaveType");
        const projectId = viewModel.getProperty("/projectId");
        const teamId = viewModel.getProperty("/teamId");
        const departmentId = viewModel.getProperty("/departmentId");

        DataService.getDispoData(year, leaveType, projectId, teamId, departmentId)
            .then((data) => {
                viewModel.setProperty("/dispo", data.dispo);
            })
            .catch((error) => {
                console.error("Error fetching dispo data:", error);
            });
    }

    onFilter(): void {
        this.getDispoData();
    }

    onSearchFieldLiveChange(oEvent: SearchField$LiveChangeEvent): void {

        var oBinding = oEvent.getSource().getParent().getParent().getBinding("items") as ListBinding;

        var aFilters = [];
        var sQuery = oEvent.getSource().getValue();
        if (sQuery && sQuery.length > 0) {
            aFilters.push(new Filter("firstName", FilterOperator.Contains, sQuery));
            aFilters.push(new Filter("lastName", FilterOperator.Contains, sQuery));
            const oCombinedFilter = new Filter({ filters: aFilters, and: false });
            oBinding.filter(oCombinedFilter, "Application");
        } else {
            oBinding.filter([]);
        }

    }
}
